module.exports = __webpack_public_path__ + "img/img_view_data.2255ee21.jpg";